import { motion, useReducedMotion } from 'framer-motion';

interface RotatingGlobeProps {
  size?: number;
  className?: string;
}

const twinkles = [
  { top: '8%', left: '20%', dur: 3 },
  { top: '18%', left: '80%', dur: 2.2 },
  { top: '70%', left: '10%', dur: 4 },
  { top: '82%', left: '68%', dur: 2.6 },
  { top: '40%', left: '94%', dur: 3.4 },
  { top: '4%', left: '52%', dur: 3.8 },
];

export function RotatingGlobe({ size = 320, className = '' }: RotatingGlobeProps) {
  const reduce = useReducedMotion();
  const globe = Math.round(size * 0.82);
  const s = globe / 250;
  const px = (n: number) => `${Math.round(n * s)}px`;

  const sphereShadow = [
    `0 0 ${px(20)} rgba(195,244,255,0.25)`,
    `-${px(5)} 0 ${px(8)} #c3f4ff inset`,
    `${px(15)} ${px(2)} ${px(25)} #000 inset`,
    `-${px(24)} -${px(2)} ${px(34)} #c3f4ff99 inset`,
    `${px(250)} 0 ${px(44)} #00000066 inset`,
    `${px(150)} 0 ${px(38)} #000000aa inset`,
  ].join(', ');

  return (
    <div className={`pointer-events-none relative ${className}`} style={{ width: size, height: size }} aria-hidden>
      {twinkles.map((t, i) => (
        <motion.span
          key={i}
          className="absolute h-1 w-1 rounded-full bg-cyan-100"
          style={{ top: t.top, left: t.left, boxShadow: '0 0 6px 1px rgba(195,244,255,0.7)' }}
          animate={reduce ? undefined : { opacity: [0.1, 1, 0.1] }}
          transition={reduce ? undefined : { duration: t.dur, repeat: Infinity, ease: 'easeInOut' }}
        />
      ))}
      <motion.div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full"
        style={{
          width: globe,
          height: globe,
          backgroundImage: `url("https://public.ticca.com/images/png/RotatingGlobeBgLtd.png")`,
          backgroundSize: `${globe * 2}px ${globe}px`,
          backgroundRepeat: 'repeat-x',
          backgroundPositionY: 'center',
          boxShadow: sphereShadow,
        }}
        animate={reduce ? undefined : { backgroundPositionX: ['0px', `-${globe * 2}px`] }}
        transition={reduce ? undefined : { duration: 34, repeat: Infinity, ease: 'linear' }}
      />
    </div>
  );
}
